// Keenthemes' plugins
require('./components/event-handler.js');
require('./components/util.js');
require('./components/app.js');

// Keenthemes' plugins
require('./components/menu.js');
require('./components/drawer.js');
require('./components/scroll.js');
require('./components/toggle.js');
require('./components/sticky.js');
require('./components/search.js');
require('./components/stepper.js');
require('./components/password-meter.js');
require('./components/blockui.js');
require('./components/image-input.js');
require('./components/dialer.js');
require('./components/feedback.js');
require('./components/cookie.js');
require('./components/scrolltop.js');
require('./components/swapper.js');
require('./components/_init.js');

// Layout base js
require('./layout/app.js');
require('./layout/theme-mode.js');
require('./layout/theme-mode-user.js');
require('./layout/search.js');
require('./layout/builder.js');

// Keenthemes' plugins
require('../../demo1/js/layout/aside.js');
require('../../demo1/js/layout/toolbar.js');

// Extended
require('../../extended/button-ajax.js');
require('../../extended/js/custom/authentication/session-timeout');
